import "./content/fonts/fonts.scss"
import "./src/styles/index.scss"